module.exports = __webpack_public_path__ + "img/Mover_Front_Side_Right_Transparent.0227d324.svg";